class PushCard extends window.BAO.CustomElement() {
  setupListeners () {
    this.handleSelect = this.handleSelect.bind(this)

    if (this?.els?.select?.exists && this?.els?.button?.exists) {
      this.listeners.add(this.els.select.element, `change`, this.handleSelect)
    }
  }

  handleSelect (e) {
    const selectedOption = e.target.options[e.target.selectedIndex]
    const dataLabel = selectedOption.getAttribute('data-label')

    this.els.button.element.setAttribute('aria-label', dataLabel)
  }
}

if (!customElements.get('push-card')) {
  customElements.define('push-card', PushCard)
}
